import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { Contract_Status_Enum } from '@kheops/graphql';
import ContractRequestButton from '../company/ContractRequestButton';
import ResumeNegotiationButton, { resumeNegotiationButtonClassName } from '../company/ResumeNegotiationButton';
import { contractAtom, currentContextAtom } from '../state';

interface WishlistContactButtonProps {
  supplierId: string;
}

export default function WishlistContactButton({ supplierId }: WishlistContactButtonProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'contracts']);
  const { companyId } = useAtomValue(currentContextAtom);
  const supplierContractAtom = useMemo(
    () => contractAtom(companyId, supplierId),
    [companyId, supplierId],
  );
  const contract = useAtomValue(supplierContractAtom);

  if (contract?.status === Contract_Status_Enum.Unsigned) {
    return (
      <Box
        sx={{
          [`& .${resumeNegotiationButtonClassName}`]: {            
            width: '100%',
          }
        }}
      >
        <ResumeNegotiationButton
          contract={contract}
          actionName={'contracts:negotiations_in_progress'}
          buttonVariant={"outlined"}
        />
      </Box>
    );
  }

  return (
    <ContractRequestButton
      companyId={supplierId}
      buttonContent={t('common:contact_supplier')}
      buttonProps={{
        startIcon: <MessageOutlinedIcon />,
        sx: {
          width: '100%',
        },
      }}
    />
  );
}
